import { notifyError } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const singleAuctionDetails = (id) => async (dispatch) => {
  dispatch({ type: "SINGLE_OFFER_LOADING" });
  try {
    const { data } = await auction.get(`/auction/read/single-auction/${id}`);
    dispatch({ type: "GET_SINGLE_AUCTION", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "SINGLE_OFFER_LOADDED" });
  }
};


export const singleCompletedAuctionDetails = (id) => async (dispatch) => {
  dispatch({ type: "COMPLETED_SINGLE_AUCTION_LOADING" });
  try {
    const { data } = await auction.get(`/auction/read/completed/single-auction/${id}`);
    dispatch({ type: "COMPLETED_SINGLE_AUCTION_SUCCESS", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "COMPLETED_SINGLE_AUCTION_FAILED" });
  }
};
